module.exports = __webpack_public_path__ + "img/demo-photo04.12085889.jpg";